import type { UpdateEventListDetail, UpdateEventSelectionDetail } from '../types';
import { formToObject, invokeJsonEncoding, invokeMultipartEncoding, isSafari } from '../js-utils/_shared/form-utils';

/**
 * One selectable subtype of a service (key/value pair used to build the subtype dropdown)
 */
interface ServiceOption {
    id: string;
    nombre: string;
}

/**
 * A service and its subtypes. `messages` is parallel to `options`: the message at
 * index i is the placeholder to show when the subtype at index i is selected.
 */
interface Service {
    key: string;
    options: ServiceOption[];
    messages: string[];
}

interface Props {
    services: Service[];
    messageElemId: string;
}

export default function init(container: HTMLElement, { services, messageElemId }: Props) {
    const formElement = container as HTMLFormElement;
    if (!formElement || !services || !messageElemId) {
        return;
    }
    const messageElem = container.querySelector('#' + messageElemId) as HTMLTextAreaElement;
    if (!messageElem) {
        return;
    }
    const defaultPHolder = messageElem.placeholder;
    let currentService: Service | undefined;

    const handleServiceChanged = async (e: Event) => {
        const customEvent = e as CustomEvent<UpdateEventSelectionDetail>;
        const { key } = customEvent.detail;
        currentService = services.find((x) => x.key === key);
        const options = currentService?.options || [];
        messageElem.placeholder = defaultPHolder;
        document.dispatchEvent(new CustomEvent<UpdateEventListDetail>('updateSubtypes', { detail: { options } }));
    };

    const handleSubtypeChanged = async (e: Event) => {
        const customEvent = e as CustomEvent<UpdateEventSelectionDetail>;
        const { index } = customEvent.detail;
        messageElem.placeholder = currentService?.messages[index] || defaultPHolder;
    };

    document.addEventListener('nestedS:serviceChanged', handleServiceChanged);
    document.addEventListener('nestedS:subtypeChanged', handleSubtypeChanged);
}
